import { default as npm } from 'package.json';
import { Injectable, NgZone } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';  
import { RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AppService {
	
	public environment: {environment: any, version: string} = {
		environment, version: npm.version
	};

	public isMobile: boolean = this.breakpointObserver.isMatched(Breakpoints.Handset);
	public isLandscape: boolean = this.breakpointObserver.isMatched([Breakpoints.TabletLandscape, Breakpoints.WebLandscape]);
	public isDevelopment: boolean = !this.environment.environment.production && !this.environment.environment.beta;
	public isBeta: boolean = this.environment.environment.production && this.environment.environment.beta;
	public isDark: boolean = window.matchMedia("(prefers-color-scheme: dark)").matches;
    public isFramed: boolean = window.self !== window.top

	private favicon: HTMLLinkElement = document.querySelector('link[rel="icon"]');
	private faviconSize: number = 256;

	constructor(private ngZone: NgZone,
				private breakpointObserver: BreakpointObserver) {}

	hasFocus (): boolean {
		return document.hasFocus();
	}

	onNavigateSubject: Subject<RouterStateSnapshot> = new Subject();

	onNavigate (): Observable<RouterStateSnapshot> {
		return this.onNavigateSubject.asObservable();
	}

	titleNotify () {
		this.ngZone.runOutsideAngular(() => {

			const canvas: HTMLCanvasElement = document.createElement('canvas');
			const context: CanvasRenderingContext2D = canvas.getContext('2d');
			const img: HTMLImageElement = document.createElement('img');
	
			canvas.width = this.faviconSize;
			canvas.height = this.faviconSize;
	
			img.src = this.favicon.href;
			img.onload = () => {

				context.drawImage(img, 0, 0, this.faviconSize, this.faviconSize);

				context.save();
				context.globalCompositeOperation='destination-out';
				context.beginPath();
				context.arc(canvas.width - this.faviconSize / 5, this.faviconSize / 5, this.faviconSize / 2.5, 0, 2 * Math.PI);
				context.fill();
				context.restore();

				context.beginPath();
				context.arc(canvas.width - this.faviconSize / 5, this.faviconSize / 5, this.faviconSize / 5, 0, 2 * Math.PI);
				context.fillStyle = '#f44336';
				context.fill();

				this.favicon.href = canvas.toDataURL('image/png');
			};
		});
	}

	titleClear () {
		this.ngZone.runOutsideAngular(() => {
			Object.entries({
				'no-preference': 'favicon',
				'light': 'favicon',
				'dark': 'favicon-white'
			})
			.each(([prefersColorScheme, favicon]) => 
				(<HTMLLinkElement> document.querySelector(`link[rel="icon"][media="(prefers-color-scheme:${prefersColorScheme})"]`)).href = `${favicon}.ico`
			)
		});
	}
}